<template>
    <kgr-dropdown
        display="title"
        :options="filteredDrafts"
        :label="tLabel"
        :value="value"
        :loading="loading"
        @post-input="onInput"
    />
</template>

<script>
import Dropdown from './Dropdown.vue';
import LetterDraftRepository from '../../../../js/repository/LetterDraftRepository.js';

export default {
    components: {
        'kgr-dropdown': Dropdown,
    },
    props: {
        clubId: {
            type: Number,
            required: true,
        },
        entity: {
            type: String,
            required: true,
            validator(value) {
                return ['member', 'dog'].includes(value);
            },
        },
        value: {
            required: true,
        },
        excludedIds: {
            type: Array,
            required: false,
            default: () => {
                return [];
            },
        },
        hideLabel: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
    data() {
        return {
            loading: true,
            drafts: [],
        };
    },
    computed: {
        tLabel() {
            return this.hideLabel ? null : this.$t('draft');
        },
        filteredDrafts() {
            return this.drafts.filter((draft) => this.excludedIds.indexOf(draft.id) === -1);
        },
    },
    created() {
        LetterDraftRepository
            .findAll(this.clubId, this.entity)
            .then((data) => {
                this.drafts = data;
                this.loading = false;
            })
            .catch(() => this.$notify.error('error.loadingData'))
            .finally(() => this.loading = false);
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        },
    },
};
</script>
